import { useState } from "react";
import { toast } from "sonner";
import { Boxes } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";
import { fmtDate } from "@/lib/format";

function Row({ s, onApply, reload, edit }) {
  const [note, setNote] = useState("");
  const [ask, setAsk] = useState(false);
  const dismiss = async () => { try { await api.post(`/billing-lines/suggestions/${s.id}/dismiss`, { note }); toast.success("Suggestion dismissed"); reload(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <li className="flex flex-wrap items-center gap-2" data-testid={`billing-suggestion-${s.id}`}>
      <span><b>{s.change_source}</b> · <span className="font-mono">{s.asset_code}</span> {s.unit_name} from {fmtDate(s.effective_date)} → {s.line_id ? <>period {s.period_no}{s.days_affected != null ? ` (${s.days_affected} of ${s.period_days} days)` : ""}</> : <span className="text-amber-700">no open billing period - generate or add one</span>}</span>
      {edit && s.line_id && <Button size="sm" className="h-7" onClick={() => onApply(s)} data-testid={`billing-suggestion-apply-${s.id}`}>Apply to period {s.period_no}</Button>}
      {edit && !ask && <Button size="sm" variant="outline" className="h-7" onClick={() => setAsk(true)} data-testid={`billing-suggestion-dismiss-${s.id}`}>No change needed</Button>}
      {ask && <><Input className="h-7 w-56" placeholder="Why no billing change?" value={note} onChange={(e) => setNote(e.target.value)} data-testid={`billing-suggestion-note-${s.id}`} />
        <Button size="sm" variant="outline" className="h-7" disabled={!note.trim()} onClick={dismiss} data-testid={`billing-suggestion-dismiss-save-${s.id}`}>Dismiss</Button></>}
    </li>
  );
}

// Asset added to / removed from this contract's Asset Group -> suggested billing change on the matching period
export function BillingSuggestions({ rows, reload, onApply, edit }) {
  if (!rows?.length) return null;
  return (
    <div className="mb-3 rounded border border-indigo-200 bg-indigo-50/60 px-3 py-2 text-xs" data-testid="billing-suggestions">
      <b className="flex items-center gap-1.5 text-indigo-900 mb-1"><Boxes className="h-3.5 w-3.5" />Asset changes that may affect billing ({rows.length})</b>
      <ul className="space-y-1">{rows.map((s) => <Row key={s.id} s={s} onApply={onApply} reload={reload} edit={edit} />)}</ul>
    </div>
  );
}
